import {
  getArticleByQueryPaginated,
  getAutocompleteSuggestions,
} from "../../services/serverlessSearchService.js";

// Query definitions shared by the search page and its route loader, so both
// land on one cache entry.
export const RESULTS_PER_PAGE = 8;
const FIVE_MINUTES = 5 * 60 * 1000;

export const searchArticlesQuery = (searchQuery, pageNumber, activeFilter) => ({
  queryKey: ["articles", searchQuery, pageNumber, activeFilter],
  queryFn: () =>
    getArticleByQueryPaginated(
      searchQuery,
      pageNumber * RESULTS_PER_PAGE,
      RESULTS_PER_PAGE,
      activeFilter,
    ),
  staleTime: FIVE_MINUTES, // avoid refetching on tab switches
});

// Completion-suggester lookup for the vehicle card.
export const vehicleSuggestQuery = (searchQuery) => ({
  queryKey: ["vehicleCardSuggest", searchQuery],
  queryFn: () => getAutocompleteSuggestions(searchQuery, 5),
  staleTime: FIVE_MINUTES,
});

// What /search?q= requests on first render: page one of all results, plus the
// vehicle-card lookup once the term is long enough to name a vehicle.
export const searchRouteQueries = (searchParams) => {
  const searchQuery = searchParams.get("q") || "";
  if (!searchQuery) {
    return [];
  }
  return [
    searchArticlesQuery(searchQuery, 0, "all"),
    searchQuery.length > 1 ? vehicleSuggestQuery(searchQuery) : null,
  ];
};
